
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jjK63", function(module, exports) {

$parcel$export(module.exports, "HomeActions", () => $1bd15dacda369ff0$export$ae2177c1f0d2b72c);
/* home-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $gwFTX = parcelRequire("gwFTX");
const $1bd15dacda369ff0$var$styles = {
    root: "_zulp1b66 _yyhykb7n _4t3i1osq _4cvr1h6o _1e0c1txw",
    logoPaddingStyles: "_pwyo12x7",
    contentMinWidthStyles: "_glte1ris _15ri1mjv _1gs5usvi"
}; /**
    * __Home actions__
    *
    * Wrapper for the top navigation actions on the inline-start (left) side of the top navigation.
    */ 
const $1bd15dacda369ff0$export$ae2177c1f0d2b72c = ({ children: children, testId: testId })=>{
    const ref = (0, $gwFzn.useContext)((0, $gwFTX.HomeActionsAttachRef));
    const elementRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $dh538.fg)('platform_fix_component_state_update_for_suspense')) ref(elementRef.current);
    }, [
        elementRef,
        ref
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ref: (0, $dh538.fg)('platform_fix_component_state_update_for_suspense') ? elementRef : ref,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            $1bd15dacda369ff0$var$styles.root,
            (0, $dh538.fg)('platform_design_system_nav4_top_nav_min_widths') ? $1bd15dacda369ff0$var$styles.contentMinWidthStyles : // Removing the extra logo padding when applying the content min width
            $1bd15dacda369ff0$var$styles.logoPaddingStyles
        ]),
        children: children
    });
};

});

parcelRegister("eOSTl", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $aae804bfdfa76059$export$9923361bd43fa030);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kNHXO = parcelRequire("kNHXO");

var $i6ukv = parcelRequire("i6ukv");
const $aae804bfdfa76059$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
const $aae804bfdfa76059$export$9923361bd43fa030 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, interactionName: interactionName, isSelected: isSelected, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $i6ukv.IconButton), {
        ref: ref,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kNHXO))),
        label: label,
        appearance: "subtle",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        interactionName: interactionName,
        isTooltipDisabled: false,
        tooltip: $aae804bfdfa76059$var$toggleButtonTooltipOptions,
        isSelected: isSelected
    }));

});

parcelRegister("dZUTc", function(module, exports) {

$parcel$export(module.exports, "themedLogoIcon", () => $d6b0affe0a59851c$export$24328117f1132113);
$parcel$export(module.exports, "themedLogoText", () => $d6b0affe0a59851c$export$91b0830f8f4ab279);
$parcel$export(module.exports, "NavLogo", () => $d6b0affe0a59851c$export$b6394419753329e);
/* nav-logo.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $ddbVR = parcelRequire("ddbVR");

var $dh538 = parcelRequire("dh538");

var $fpGTa = parcelRequire("fpGTa");

var $4QwsP = parcelRequire("4QwsP");
const $d6b0affe0a59851c$export$24328117f1132113 = '--ds-top-bar-logo-icon';
const $d6b0affe0a59851c$export$91b0830f8f4ab279 = '--ds-top-bar-logo-text';
const $d6b0affe0a59851c$var$anchorStyles = {
    root: "_2rkoiti9 _1e0c1txw _4cvr1h6o _4t3izwfg",
    newBorderRadius: "_2rkoftgi",
    newMargin: "_ahbq1b66",
    newInteractionStates: "_irr3166n _1di61dty",
    newInteractionStatesCustomTheming: "_irr31rps _1di6qtgh"
};
const $d6b0affe0a59851c$var$sharedIconOrLogoContainerStyles = {
    root: "_1reo15vq _18m915vq _bna71tcg _rtys1kw7 _1jpx1f51",
    appIconTilePaddingFlagged: "_18zr1b66"
};
const $d6b0affe0a59851c$var$iconContainerStyles = {
    root: "_18zr1b66 _1e0c1txw _p12f1tcg _vchh18uv _10y4glyw"
};
const $d6b0affe0a59851c$var$logoContainerStyles = {
    root: "_18zru2gc _1e0cglyw _p12fnklw _vchh18uv _10y41txw"
}; /**
    * __Nav logo__
    *
    * The product logo for the top navigation.
    *
    * To provide a responsive experience, it requires both a logo and an icon component.
    * The logo component will be used for large viewports, and the icon component will be used for small viewports.
    */ 
const $d6b0affe0a59851c$export$b6394419753329e = ({ href: href, logo: logo, icon: icon, onClick: onClick, label: label })=>{
    const ref = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        return;
    }, []);
    const hasCustomTheme = (0, $4QwsP.useHasCustomTheme)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fpGTa.default), {
        ref: ref,
        "aria-label": label,
        href: href,
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $ddbVR.cx)($d6b0affe0a59851c$var$anchorStyles.root, (0, $dh538.fg)('platform_design_system_nav_logo_interaction_states') && $d6b0affe0a59851c$var$anchorStyles.newMargin, (0, $dh538.fg)('platform_design_system_nav_logo_interaction_states') && $d6b0affe0a59851c$var$anchorStyles.newBorderRadius, (0, $dh538.fg)('platform_design_system_nav_logo_interaction_states') && (hasCustomTheme ? $d6b0affe0a59851c$var$anchorStyles.newInteractionStatesCustomTheming : $d6b0affe0a59851c$var$anchorStyles.newInteractionStates)),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                className: (0, $35pXk.default)([
                    $d6b0affe0a59851c$var$sharedIconOrLogoContainerStyles.root,
                    $d6b0affe0a59851c$var$iconContainerStyles.root,
                    (0, $dh538.fg)('platform-team25-app-icon-tiles') && $d6b0affe0a59851c$var$sharedIconOrLogoContainerStyles.appIconTilePaddingFlagged
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($d6b0affe0a59851c$var$NavLogoRenderer, {
                    logoOrIcon: icon
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                className: (0, $35pXk.default)([
                    $d6b0affe0a59851c$var$sharedIconOrLogoContainerStyles.root,
                    $d6b0affe0a59851c$var$logoContainerStyles.root,
                    (0, $dh538.fg)('platform-team25-app-icon-tiles') && $d6b0affe0a59851c$var$sharedIconOrLogoContainerStyles.appIconTilePaddingFlagged
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($d6b0affe0a59851c$var$NavLogoRenderer, {
                    logoOrIcon: logo
                })
            })
        ]
    });
};
function $d6b0affe0a59851c$var$NavLogoRenderer({ logoOrIcon: LogoOrIcon }) {
    const hasCustomTheme = (0, $4QwsP.useHasCustomTheme)();
    if (hasCustomTheme) return /*#__PURE__*/ (0, $7UHDa.jsx)(LogoOrIcon, {
        size: "small",
        label: "",
        iconColor: `var(${$d6b0affe0a59851c$export$24328117f1132113})`,
        textColor: `var(${$d6b0affe0a59851c$export$91b0830f8f4ab279})`
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)(LogoOrIcon, {
        size: "small",
        label: "",
        appearance: "brand"
    });
}

});

parcelRegister("eDezy", function(module, exports) {

$parcel$export(module.exports, "CommonActions", () => $fa2ad40f274f12e2$export$deb4c0713194b9f5);
/* common-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $fa2ad40f274f12e2$var$styles = {
    root: "_zulpu2gc _yyhycs5v _1bsb1osq _4cvr1h6o",
    oldLayoutStyles: "_1e0c1txw _1bahh9n0 _1odf1h6o",
    newLayoutStyles: "_1e0c1txw _1bahh9n0 _181n11p5 _1j8b15b0 _lagd1bp4 _1t4c1ris _12e8h9n0"
}; /**
    * __Common actions__
    *
    * Wrapper for the actions in the middle of the top navigation.
    *
    * Expects that the search bar is the first child.
    * If it is not, you might see unexpected layout behavior.
    */ 
const $fa2ad40f274f12e2$export$deb4c0713194b9f5 = ({ children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            $fa2ad40f274f12e2$var$styles.root,
            (0, $dh538.fg)('platform_design_system_nav4_top_nav_columns') ? $fa2ad40f274f12e2$var$styles.newLayoutStyles : $fa2ad40f274f12e2$var$styles.oldLayoutStyles
        ]),
        children: children
    });

});

parcelRegister("b7AUB", function(module, exports) {

$parcel$export(module.exports, "UserActions", () => $b0adfd2a5257ba5a$export$2fb70d5e506c6bc2);
/* user-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $ddbVR = parcelRequire("ddbVR");

var $bNwbD = parcelRequire("bNwbD");

var $9VJDA = parcelRequire("9VJDA");

var $dh538 = parcelRequire("dh538");

var $lGgRw = parcelRequire("lGgRw");

var $2hNw6 = parcelRequire("2hNw6");

var $dM2NO = parcelRequire("dM2NO");

var $4QwsP = parcelRequire("4QwsP");

var $i6ukv = parcelRequire("i6ukv");
const $b0adfd2a5257ba5a$var$containerStyles = {
    root: "_yyhy11wp _1e0c1txw _1bahh9n0 _1ul9zwfg",
    newLayoutStyles: "_1d2y1ris",
    contentMinWidthStyles: "_glte1ris _15ri1mjv _1gs5usvi _ndwch9n0"
};
const $b0adfd2a5257ba5a$var$listStyles = {
    root: "_zulp1b66 _4cvr1h6o _1e0c1txw",
    hideOnSmallViewport: "_1e0cglyw _181n1txw",
    popupContainer: "_1yt4u2gc"
}; /**
    * __User actions__
    *
    * Wrapper for the top navigation actions on the inline-end (right) side of the top navigation.
    *
    * On small viewports, the children will be placed inside a popup, and a button will be rendered to open the popup.
    * This is to prevent the actions from overflowing the top navigation.
    */ 
const $b0adfd2a5257ba5a$export$2fb70d5e506c6bc2 = ({ children: children, label: label = 'Actions', showMoreButtonLabel: showMoreButtonLabel = 'Show more' })=>{
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false); // Always setting to `false` for the initial render (will flip in an effect for mobile)
    const [isMobile, setIsMobile] = (0, $gwFzn.useState)(false); // Note: `query` is a stable value between renders
    const query = (0, $2hNw6.UNSAFE_useMediaQuery)('below.sm', function onChange(event) {
        setIsMobile(event.matches); // Any time we shift between mobile and desktop
        // We always close the popup
        setIsOpen(false);
    });
    (0, $bNwbD.useLayoutEffect)(()=>{
        // The default is `false`, and desktop will remain as `false` (no re-render).
        // Mobile will flip from `false` to `true`.
        setIsMobile(query?.matches ?? false);
    }, [
        query
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("nav", {
        "aria-label": label,
        className: (0, $35pXk.default)([
            $b0adfd2a5257ba5a$var$containerStyles.root,
            (0, $dh538.fg)('platform_design_system_nav4_top_nav_columns') && $b0adfd2a5257ba5a$var$containerStyles.newLayoutStyles,
            (0, $dh538.fg)('platform_design_system_nav4_top_nav_min_widths') && $b0adfd2a5257ba5a$var$containerStyles.contentMinWidthStyles
        ]),
        children: isMobile ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-start",
            shouldRenderToParent: true,
            content: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4QwsP.HasCustomThemeContext).Provider, {
                    value: false,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dM2NO.List), {
                        xcss: (0, $ddbVR.cx)($b0adfd2a5257ba5a$var$listStyles.root, $b0adfd2a5257ba5a$var$listStyles.popupContainer),
                        children: children
                    })
                }),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $i6ukv.IconButton), {
                    ...triggerProps,
                    label: showMoreButtonLabel,
                    isSelected: isOpen,
                    onClick: ()=>setIsOpen(!isOpen),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                    isTooltipDisabled: false
                })
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dM2NO.List), {
            xcss: (0, $ddbVR.cx)($b0adfd2a5257ba5a$var$listStyles.root, $b0adfd2a5257ba5a$var$listStyles.hideOnSmallViewport),
            children: children
        })
    });
};

});

parcelRegister("lXg1y", function(module, exports) {

$parcel$export(module.exports, "UserAction", () => $f078b0cf038bfe3a$export$d344b04822cd68e8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dukN8 = parcelRequire("dukN8");

var $i6ukv = parcelRequire("i6ukv");
const $f078b0cf038bfe3a$export$d344b04822cd68e8 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem = true }, forwardedRef)=>{
    const Wrapper = isListItem ? (0, $dukN8.ListItem) : (0, $gwFzn.Fragment);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $i6ukv.IconButton), {
            ref: forwardedRef,
            icon: icon,
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            appearance: "subtle",
            isSelected: isSelected,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup
        })
    });
});

});

parcelRegister("eBhbk", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $afbd63c287e69752$export$36ba2f559d49a8f6);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ckcSY = parcelRequire("ckcSY");

var $2uMjy = parcelRequire("2uMjy");

var $lXg1y = parcelRequire("lXg1y");
const $afbd63c287e69752$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $afbd63c287e69752$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(function Notifications({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem, badge: badge }, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2uMjy.BadgeContainer), {
        id: $afbd63c287e69752$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lXg1y.UserAction), {
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            isSelected: isSelected,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            ref: ref,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ckcSY))),
            // We explicitly set the UserAction to not be a list item,
            // because the BadgeContainer already has a list item role (if `isListItem` is true)
            isListItem: false
        })
    });
});

});
parcelRegister("2uMjy", function(module, exports) {

$parcel$export(module.exports, "BadgeContainer", () => $aed22086c0956b03$export$f710265eb5a003da);
/* badge-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $aed22086c0956b03$var$styles = {
    root: "_kqswh2mm _1e0c1txw",
    badgeContainer: "_kqswstnw _o5721q9c _152tr5cr _1e02utpp _lcxvglyw"
};
const $aed22086c0956b03$export$f710265eb5a003da = ({ children: children, id: badgeId, badge: Badge, isListItem: isListItem = true })=>/*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
        role: isListItem ? 'listitem' : undefined,
        className: (0, $35pXk.default)([
            $aed22086c0956b03$var$styles.root
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                id: badgeId,
                "aria-hidden": true,
                className: (0, $35pXk.default)([
                    $aed22086c0956b03$var$styles.badgeContainer
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(Badge, {})
            })
        ]
    });

});



//# sourceMappingURL=top-nav.f88e759b.js.map
